import formButton from '@/components/common/form-button/form-button.vue'
import Multiselect from 'vue-multiselect'
import templateModal from '@/components/pages/page-templates/templateModal/templateModal.vue'
import cardTemplate from '@/components/cards/card-template/card-template.vue'
import subpageHeader from '@/components/app/header/subpage-header/subpage-header.vue'
import infiniteScroll from 'vue-infinite-scroll'
import spinner from '@/components/common/spinner/spinner.vue'
import { mapActions, mapState } from 'vuex'
import { find } from 'lodash'
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'
import modal from '@/components/common/modal/modal.vue'

export default {
  directives: { infiniteScroll },
  components: {
    formButton,
    templateModal,
    cardTemplate,
    Multiselect,
    subpageHeader,
    spinner,
    flatPickr,
    modal
  },
  data() {
    return {
      searchParams: {
        name: null,
        startDate: null,
        country: null,
        age: null,
        mechanic: null
      },
      templates: [],
      searchMessage: '',
      currentTemplate: '',
      isSearchTriggered: false,
      busy: false,
      total: 0,
      datetimePickerOptions: {
        minDate: Date.now()
      }
    }
  },
  computed: {
    ...mapState('popup', ['currentPopup']),
    ...mapState('countries', ['countriesList']),
    ...mapState('competitionMechanic', ['mechanicList']),
    ...mapState('template', ['ageOptions', 'templatesPerPage']),
    extendedMechanicList: function () {
      let array = Array.from(this.mechanicList)
      array.unshift('')
      return array
    },
    extendedCountriesList: function () {
      let array = Array.from(this.countriesList)
      array.unshift('')
      return array
    }
  },
  methods: {
    ...mapActions('popup', ['setCurrentPopup']),
    ...mapActions('template', ['searchTemplates']),
    ...mapActions('countries', ['getCountriesList']),
    ...mapActions('competitionMechanic', ['getMechanicList']),
    onSearchClick: async function () {
      this.isSearchTriggered = true
      if (
        !this.searchParams.startDate ||
        !this.searchParams.country ||
        !this.searchParams.age ||
        !this.searchParams.mechanic
      ) {
        return
      }
      if (moment(this.searchParams.startDate) <= moment().add(14, 'days')) {
        this.setCurrentPopup('anticipatedSearchStartDateTooShort')
        this.searchParams = {}
        this.isSearchTriggered = false
      } else {
        this.search()
      }
    },
    searchAll: function () {
      this.searchParams = {}
      this.isSearchTriggered = false
      this.templates = []
      this.search()
    },
    async search() {
      try {
        const res = await this.searchTemplates(Object.assign({}, this.searchParams, { limit: this.limit }))
        this.templates = res.data
        this.total = res.total
        this.searchMessage = `Found templates: ${this.total}`
      } catch (e) {
        this.$notify({
          text: 'Error while getting templates',
          type: 'error'
        })
      }
    },
    showModal(templateId) {
      this.currentTemplate = find(this.templates, (template) => template.id === templateId)
      if (event.target.nodeName !== 'BUTTON') {
        this.setCurrentPopup('template')
      }
    },
    submitOnEnter(event) {
      if (event.keyCode === 13) {
        this.onSearchClick()
        event.preventDefault()
      }
    },
    loadMore: async function () {
      if (this.templates.length < this.total) {
        this.busy = true
        const moreData = await this.searchTemplates(
          Object.assign({}, this.searchParams, { offset: this.templates.length })
        )
        this.templates = this.templates.concat(moreData.data)
        this.busy = false
      }
    }
  },
  created() {
    this.getCountriesList()
    this.getMechanicList()
    this.search()
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/page-templates/page-templates.js